<div class="modal-signup modal-content">
  <div>
    <div class="card col-12 my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Profile Info

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px">



        <ul class="nav nav-tabs nav-tab-service2" id="tabContent">
          <li class="active margin-right-5px font-size-14px"><a class="nav-itemerp active" href="#details" data-toggle="tab">General</a></li>
          <li class="margin-right-5px font-size-14px"><a class="nav-itemerp" href="#Education" data-toggle="tab">Education</a></li>
          <li class="margin-right-5px font-size-14px"><a class="nav-itemerp" href="#Referral" data-toggle="tab">Referral</a></li>
          <li class="margin-right-5px font-size-14px"><a class="nav-itemerp" href="#address" data-toggle="tab">Address</a></li>
          <li class="margin-right-5px font-size-14px"><a class="nav-itemerp" href="#contact" data-toggle="tab">Contact</a></li>

        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="details">
            <div class="card">
              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="row">
                  <div class="col-12 padding-l-0px">
                    <form class="form" novalidate="" (ngSubmit)="General()" #f="ngForm">
                      <div class="card col-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <!--<div class="row">

                            <div class="form-group offset-1 col-3">

                              <div class="image-upload-box font-size-16px">

                                <img class="img-circle-65px" [src]='' height="50" width="50" alt="">
                                
                              </div>                              

                              <div class="user-status">

                              </div>
                            </div>
                          </div>-->
                          <div class="row">
                            <div class="col-12">
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="firstName"><span>*</span> Name Prefix</label>
                                    </div>
                                    <div class="col-7">
                                      <CodeTypeValue CodeType="NPRE"
                                                     id="CurrentSavePatientInfoRequest.Prefix" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Prefix" SelectedValue="{{CurrentSavePatientInfoRequest.Prefix}}"
                                                     name="CurrentSavePatientInfoRequest.Prefix" required #Prefix="ngModel">
                                      </CodeTypeValue>                                      

                                    </div>


                                  </div>

                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="firstName"><span>*</span> Name </label>
                                    </div>
                                    <div class="col-7">

                                      <input type="text" class="form-control" placeholder="First Name"
                                             id="CurrentSavePatientInfoRequest.DisplayName"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                             name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1" #Name="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Name.valid && (Name.dirty || Name.touched) && Name.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Name.valid && Name.errors.pattern)">(special characters are not allowed)</small>

                                    </div>

                                  </div>

                                </div>
                              </div>

                              <div class="row">
                                <div class="form-group col-12  margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="birthDate"><span>*</span> Date of Birth  </label>
                                    </div>
                                    <div class="col-7">
                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp1" [(ngModel)]="DOB" ngbDatepicker  #d1="ngbDatepicker" #Birth="ngModel" required>
                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>                              
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName"><span>*</span> Sex</label>
                                    </div>

                                    <div class="col-7">
                                      <CodeTypeValue CodeType="Sex"
                                                     id="CurrentSavePatientInfoRequest.Gender" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Gender" SelectedValue="{{CurrentSavePatientInfoRequest.Gender}}"
                                                     name="CurrentSavePatientInfoRequest.Gender" required #Sex="ngModel">
                                      </CodeTypeValue>

                                    </div>
                                  </div>


                                </div>

                              </div>

                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName">Occupation</label>
                                    </div>

                                    <div class="col-7">
                                      <input type="text" class="form-control" placeholder="Occupation"
                                             id="CurrentSavePatientInfoRequest.Occupation"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Occupation"
                                             name="CurrentSavePatientInfoRequest.Occupation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1">

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName">Organisation</label>
                                    </div>

                                    <div class="col-7">
                                      <input type="text" class="form-control" minlength="2" placeholder="Organisation"
                                             id="CurrentSavePatientInfoRequest.Institution"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Institution"
                                             name="CurrentSavePatientInfoRequest.Institution" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30">


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName">Religion</label>
                                    </div>

                                    <div class="col-7">
                                      <CodeTypeValue CodeType="RELGN"
                                                     id="CurrentSavePatientInfoRequest.Religion" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Religion" SelectedValue="{{CurrentSavePatientInfoRequest.Religion}}"
                                                     name="CurrentSavePatientInfoRequest.Religion">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>


                            </div>

                            <div class="col-12">
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName">Blood Group</label>
                                    </div>

                                    <div class="col-7">
                                      <CodeTypeValue CodeType="BGRP"
                                                     id="CurrentSavePatientInfoRequest.BloodGroup"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.BloodGroup" SelectedValue="{{CurrentSavePatientInfoRequest.BloodGroup}}"
                                                     name="CurrentSavePatientInfoRequest.BloodGroup">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName"><span>*</span> Marital Status</label>
                                    </div>

                                    <div class="col-7">
                                      <CodeTypeValue CodeType="MARTL"
                                                     id="CurrentSavePatientInfoRequest.MaritalStatus" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.MaritalStatus" SelectedValue="{{CurrentSavePatientInfoRequest.MaritalStatus}}"
                                                     name="CurrentSavePatientInfoRequest.MaritalStatus" required #Status="ngModel">
                                      </CodeTypeValue>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName">Nationality</label>
                                    </div>

                                    <div class="col-7">
                                      <CodeTypeValue CodeType="NATN"
                                                     id="CurrentSavePatientInfoRequest.Nationality" PassType="Long"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Nationality" SelectedValue="{{CurrentSavePatientInfoRequest.Nationality}}"
                                                     name="CurrentSavePatientInfoRequest.Nationality">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <!--<div class="row">
                                <div class="form-group col-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-5 text-align-right">
                                      <label for="email address">Primary Care Giver</label>
                                    </div>                                    
                                    <div class="col-5">
                                      <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorn">{{PrimaryDoctor}}</label>
                                      <label class="font-size-14 margin-bottom-0px" *ngIf="PrimaryDoctorO">{{CurrentSavePatientInfoRequest.PrimaryDoctor}}</label>
                                    </div>
                                    <div class="col-2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectPrimaryDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                    </div>
                                  </div>
                                </div>
                              </div>-->
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-5 text-align-right">
                                     <label for="email address" class="margin-bottom-0px margin-top-3px">Birth Identification</label>
                                    </div>
                                    <div class="col-7">
                                      <input type="text" class="form-control" placeholder="BirthIdentification"
                                             id="CurrentSavePatientInfoRequest.BirthIdentification1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.BirthIdentification1"
                                             name="CurrentSavePatientInfoRequest.BirthIdentification1" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1">
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-5 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-3px">ID Proof</label>
                                    </div>

                                    <div class="col-7">
                                      <input type="text" class="form-control" placeholder="ID Proof"
                                             id="CurrentSavePatientInfoRequest.IdProof"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.IdProof"
                                             name="CurrentSavePatientInfoRequest.IdProof" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1">

                                    </div>
                                  </div>


                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                          <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="Name.errors?.required || Birth.errors?.required || Prefix.errors?.required || Sex.errors?.required || Status.errors?.required">Save</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              
            </div>


          </div>

          <div class="tab-pane" id="Education">

            <form class="form" novalidate="" (ngSubmit)="Education()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-12 padding-l-0px">
                      <div class="card col-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">Education Level</label>
                                </div>
                                <div class="col-7">
                                  <CodeTypeValue CodeType="EDU"
                                                 id="CurrentSavePatientInfoRequest.EducationTitle" PassType="Long"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.EducationTitle" SelectedValue="{{CurrentSavePatientInfoRequest.EducationTitle}}"
                                                 name="CurrentSavePatientInfoRequest.EducationTitle">
                                  </CodeTypeValue>
                                </div>
                              </div>


                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Education in Detail</label>
                                </div>
                                <div class="col-7">
                                  <input type="text" class="form-control" placeholder="Details"
                                         id="CurrentSavePatientInfoRequest.EducationInDetail"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.EducationInDetail"
                                         name="CurrentSavePatientInfoRequest.EducationInDetail" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1">
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>





          </div>          

          <div class="tab-pane" id="Referral">

            <form class="form" novalidate="" (ngSubmit)="Referral()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-12 padding-l-0px">
                      <div class="card col-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">Referral Type</label>
                                </div>
                                <div class="col-7">
                                  <CodeTypeValue CodeType="RFTP" (ngModelChange)="onChange2($event)" PassType="Long"
                                                 id="CurrentSavePatientInfoRequest.RefType"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.RefType" SelectedValue="{{CurrentSavePatientInfoRequest.RefType}}"
                                                 name="CurrentSavePatientInfoRequest.RefType">
                                  </CodeTypeValue>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='CMP' || SelectedSource=='FRND' || SelectedSource=='MEDHD' || SelectedSource=='MEDNP' || SelectedSource=='MEDNT' || SelectedSource=='MEDRD' || SelectedSource=='MEDTV'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referral Details </label>
                                </div>
                                <div class="col-7">
                                  <input type="text" class="form-control" placeholder="Referral By"
                                         id="CurrentSavePatientInfoRequest.RefDetails"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefDetails"
                                         name="CurrentSavePatientInfoRequest.RefDetails" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1">                                  
                                </div>                                
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='RGPT'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-5">                                  
                                  <label class="font-size-14 margin-bottom-0px">{{PatientName}}</label>
                                </div>
                                <div class="col-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectPatient()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='STAFF'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-5">                                  
                                  <label class="font-size-14 margin-bottom-0px">{{StaffName}}</label>
                                </div>
                                <div class="col-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectStaff()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='DOC'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-5">                                  
                                  <label class="font-size-14 margin-bottom-0px">{{ProviderName}}</label>
                                </div>
                                <div class="col-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectInternalDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='DOCEX'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referred By </label>
                                </div>
                                <div class="col-5">
                                  <input type="text" class="form-control" placeholder="Referral By"
                                  id="CurrentSavePatientInfoRequest.RefDetails"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.RefDetails"
                                  name="CurrentSavePatientInfoRequest.RefDetails" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                  maxlength="30" minlength="1">
                                </div>
                                <div class="col-2">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectExternalDoctor()"> <i class="fas fa-ellipsis-h"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>                          
                          <div class="row" *ngIf="SelectedSource=='DOC'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-7">
                                  <label class="font-size-14 margin-bottom-0px">{{ProviderNumber}}</label>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='DOCEX'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-7">
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.RefContactNo"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefContactNo"
                                         mask="(000) 000-0000"
                                         name="CurrentSavePatientInfoRequest.RefContactNo" pattern="[0-9]{10}" #Telephone1="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>                                  
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='STAFF'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-7">
                                  <label class="font-size-14 margin-bottom-0px">{{StaffNumber}}</label>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='RGPT'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-7">
                                  <label class="font-size-14 margin-bottom-0px">{{PatientNumber}}</label>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row" *ngIf="SelectedSource=='CMP' || SelectedSource=='FRND' || SelectedSource=='MEDHD' || SelectedSource=='MEDNP' || SelectedSource=='MEDNT' || SelectedSource=='MEDRD' || SelectedSource=='MEDTV'">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referral Contact</label>
                                </div>
                                <div class="col-7">                                  
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.RefContactNo"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefContactNo"
                                         mask="(000) 000-0000"
                                         name="CurrentSavePatientInfoRequest.RefContactNo" pattern="[0-9]{10}" #Telephone1="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-5 text-align-right">
                                  <label for="email address">Referral Institute</label>
                                </div>
                                <div class="col-7">
                                  <input type="text" class="form-control" placeholder="Institute"
                                         id="CurrentSavePatientInfoRequest.RefInstitute"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.RefInstitute"
                                         name="CurrentSavePatientInfoRequest.RefInstitute" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1">
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>

            </form>



          </div>


          <div class="tab-pane" id="address">

            <form class="form" novalidate="" (ngSubmit)="Adress()" #f="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-12 padding-l-0px">
                      <div class="card col-12 my-profile-form padding-lr-0px">
                        
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">Address Line1 </label>
                                </div>
                                <div class="col-7">
                                  <input type="text" class="form-control" placeholder="Address Line1"
                                         id="CurrentSavePatientInfoRequest.AddressLine1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                         name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._''\-?]*$" #AddressLine1="ngModel"
                                         maxlength="100" />
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">Address Line2 </label>
                                </div>
                                <div class="col-7">
                                  <input type="text" class="form-control" placeholder="Address Line2"
                                         id="CurrentSavePatientInfoRequest.AddressLine2"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2"
                                         name="CurrentSavePatientInfoRequest.AddressLine2" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine2="ngModel"
                                         maxlength="100" />
                                 </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">Country </label>
                                </div>
                                <div class="col-7">
                                  <CodeTypeValue CodeType="CNTR"
                                                 id="CurrentSavePatientInfoRequest.County"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.County"
                                                 name="CurrentSavePatientInfoRequest.County"
                                                 (keyChange)="Country($event)">
                                  </CodeTypeValue>
                                  
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">State </label>
                                </div>
                                <div class="col-7" *ngIf="CountryName == 'INDIA'">
                                  <CodeTypeValue CodeType="State"
                                                 id="CurrentSavePatientInfoRequest.State"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                                 name="CurrentSavePatientInfoRequest.State"></CodeTypeValue>
                                </div>
                                <div class="col-7" *ngIf="CountryName != 'INDIA'">
                                  <input type="text" class="form-control" placeholder="State"
                                         id="CurrentSavePatientInfoRequest.State"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                         name="CurrentSavePatientInfoRequest.State" pattern="^[\sa-zA-Z0-9,._\-?]*$" #State="ngModel"
                                         maxlength="100" />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">
                                    City
                                  </label>
                                </div>
                                <div class="col-7" *ngIf="CountryName == 'INDIA'">
                                  <CodeTypeValue CodeType="City"
                                                 id="CurrentSavePatientInfoRequest.City"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                                 name="CurrentSavePatientInfoRequest.City"></CodeTypeValue>                                  
                                </div>
                                <div class="col-7" *ngIf="CountryName != 'INDIA'">
                                  <input type="text" class="form-control" placeholder="City"
                                         id="CurrentSavePatientInfoRequest.City"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                         name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                                         maxlength="100" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName">Zip Code</label>
                                </div>
                                <div class="col-7">
                                  <input type="text" class="form-control" placeholder="Zip Code"
                                         id="CurrentSavePatientInfoRequest.ZipCode"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.ZipCode"
                                         name="CurrentSavePatientInfoRequest.ZipCode" #ZipCode="ngModel"
                                         maxlength="6" pattern="[0-9]{6}">
                                  <small class="form-text text-danger"
                                         *ngIf="(!ZipCode.valid && (ZipCode.dirty || ZipCode.touched) && ZipCode.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!ZipCode.valid && ZipCode.errors.pattern)">(only numbers are allowed)</small>
                                </div>
                              </div>
                            </div>
                          </div>                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" id="contact">
            <form class="form" novalidate="" (ngSubmit)="Contact()" #f="ngForm">
              <div class="card card-height-417px">
                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-12 padding-l-0px">
                      <div class="card col-12 my-profile-form padding-lr-0px">                        
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="diaplayName"><span>*</span> Mobile Phone </label>
                                </div>
                                <div class="col-7">                                  
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.Telephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                         name="CurrentSavePatientInfoRequest.Telephone1"
                                         maxlength="25" minlength="1" #phone1="ngModel">
                                </div>
                              </div>
                            </div>
                          </div>                          
                          <div class="row">
                            <div class="form-group col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-5 text-align-right">
                                  <label for="email address"> Email Address  </label>
                                </div>
                                <div class="col-7">
                                  <input type="email" class="form-control" id="CurrentSavePatientInfoRequest.Email"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Email"
                                         name="CurrentSavePatientInfoRequest.Email"
                                         placeholder="Email" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                                         #Email="ngModel" maxlength="30" minlength="4">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="CurrentSavePatientInfoRequest.Telephone1==''">Save</button>
                </div>
              </div>
            </form>
          </div>
          
        </div>
      </div>

    </div>
  </div>
</div>
